import { Fragment, useEffect, useMemo, useState } from 'react';
import '../../../../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { Button, ConfigProvider, Pagination } from 'antd';

import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { FlattenedField } from '../../../../../CustomersV2/indexV2';
import { ICustomer } from '../../../../../../api/Customer_V2/customerApi_V2';
import { ColumnKey } from '../../../../../Customers/Tabs/CarListCardClone';
dayjs.locale('vi');


import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../../../../components/NoDataTable';
import { formatNumber } from '../../../../../../services/mixin';
import { IPagination } from '../../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { CustomLoadingOverlayTable, dataPagination } from '../../../../../../until';
import { generateColumnsFromCodesAgGridReactRecordCar } from '../../../ServiceRecords/ContactInformation';
import { NODATA } from 'dns';
import { NO_DATA } from '../../../../../../env';
import { ArrowRightUpOutlined } from '../../../../../../components/ExportImgFigma';
import { NO_VIEW } from '../../../../../../services/data';

interface Props {
  loadingTableDetail: boolean
  dataFieldsActive: FlattenedField[]
  data: ICustomer[]
  pagination: IPagination

  gInfoQuestionSurvey: (id: number) => Promise<void>
  onPaginationChange: (page: number, pageSize: number) => void
}

const TabSurveyInformationTabDetail: React.FC<Props> = ({
  loadingTableDetail, dataFieldsActive, data, pagination,
  gInfoQuestionSurvey,
  onPaginationChange
}) => {

  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

  //#region Cấu hình cột
  // const memoizedColumnDefs = useMemo(() => {
  //   return generateColumnsFromCodesAgGridReactRecordCar(
  //     columnsMapShow, dataFieldsActive, undefined,
  //     () => { }
  //   );
  // }, [columnsMapShow, dataFieldsActive]);

  const memoizedColumnDefs = useMemo(() => {
    // Lấy các column từ hàm generateColumnsFromCodesAgGridReactRecordCar
    const baseColumns = generateColumnsFromCodesAgGridReactRecordCar(
      columnsMapShow, dataFieldsActive, undefined,
      () => { }
    );

    // Tạo column cho question_survey với button chỉnh sửa
    const questionSurveyColumn = {
      headerName: 'Khảo sát',
      field: 'question_survey',
      minWidth: 150,
      maxWidth: 200,
      cellRenderer: (params: any) => {
        if (!params.data) return NO_DATA;
        const { question_survey, id } = params.data

        return (
          <div className='custom-page-css flex items-center gap-2'>
            <span>{question_survey}</span>
            <Button
              className='text-sm border-none p-5-px bg-white rounded-2 cursor-pointer'
              onClick={() => gInfoQuestionSurvey(id)}
            >
              <img src={ArrowRightUpOutlined} alt="" />
            </Button>
          </div>
        );
      },
      cellRendererParams: {
        // Truyền thêm params nếu cần
      }
    };

    // Thêm column mới vào danh sách columns
    return [...baseColumns, questionSurveyColumn];
  }, [columnsMapShow, dataFieldsActive]);

  const tableData = useMemo(() => {
    return data.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.view === false ? NO_VIEW : field.value;
        return acc;
      }, {});

      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues
      };
    });
  }, [data]);

  useEffect(() => {
    const codes = dataFieldsActive.map((f) => f.fieldCode);
    setColumnsMapShow(codes);
  }, [dataFieldsActive]);
  //#endregion

  return (
    <Fragment>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
          <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
            <div className="ag-theme-alpine custom-table-ag custom-css-table"
              style={{ width: '100%', height: tableData.length === 0 ? 250 : tableData.length < 10 ? tableData.length * 65 + 65 : 650 }}
            >
              <AgGridReact
                className="my-auto-height-grid"
                getRowStyle={(params: any) => ({
                  backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                })}
                rowData={tableData}
                columnDefs={memoizedColumnDefs}
                rowHeight={55}
                overlayNoRowsTemplate={NodataTable}
                loading={loadingTableDetail}
                loadingOverlayComponent={CustomLoadingOverlayTable}
                // onGridReady={(params) => {
                //   params.api.sizeColumnsToFit();
                // }}
                // onSelectionChanged={onSelectionChanged}
                // Performance optimizations
                suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
                suppressRowVirtualisation={false} // Giữ row virtualization
                enableCellTextSelection={true}
                ensureDomOrder={true}
                debounceVerticalScrollbar={true}
                suppressScrollOnNewData={true}
                suppressDragLeaveHidesColumns={true}

                // Thêm các props sau để cải thiện scroll
                rowBuffer={20}
                maxBlocksInCache={10}
                infiniteInitialRowCount={1000}
              />
            </div>
            <ConfigProvider
              locale={viVN}
            >
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={() =>
                    `Tổng cộng ${dataPagination(
                      pagination.total,
                      pagination.pageSize,
                      pagination.current
                    ).totalPage} trang`
                  }
                  className="rs-pagination"
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>

          </div>
        </div>

      </div>
    </Fragment>
  )

}

export default TabSurveyInformationTabDetail
